import * as React from "react";
import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LogoutIcon from "@mui/icons-material/Logout";
import QueueIcon from '@mui/icons-material/Queue';

import { useContext } from "react";
import { ColorModeContext } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography className="fs-6">{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const navigate = useNavigate();

  const colorMode = useContext(ColorModeContext);

  const handleToggleColorMode = () => {
    colorMode.toggleColorMode();
  };

  const logout = async () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#cda83f !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed} width={240}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}>
                  Global Wings
                </Typography>

                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="120px"
                  height="120px"
                  src={`../../assets/global_wings.png`}
                />
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Institutes List"
              to="/home"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* <Typographyl
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Data
            </Typography> */}

            <Item
              title="Leads"
              // to="/"
              to="/leads"
              icon={<LeaderboardIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* <Item
              title="New Registration"
              to="/form"
              icon={<UpdateIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}

            <Item
              title="Requests"
              to="/requests"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Call Scheduled"
              to="/callscheduled"
              icon={<AddIcCallIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Notifications"
              to="/notifications"
              icon={<NotificationsActiveIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography> */}

            {/* <Item
              title="App Updates"
              to="appupdates"
              icon={<UpdateIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}

            

            <Item
              title="Add Questions"
              to="/updatequestions"
              icon={<QueueIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* <Box display="flex" justifyContent="" p={2}>
              <IconButton onClick={colorMode.toggleColorMode} >
                {theme.palette.mode === "dark" ? (
                  <DarkModeOutlinedIcon />
                ) : (
                  <LightModeOutlinedIcon />
                )}

              </IconButton>
              <Typography variant="h4" style={{ color: '#ffffff', fontWeight: '600' }}>
                Institutes List
              </Typography>
            </Box> */}

            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                paddingX={2}
                sx={{
                  cursor: "pointer",
                }}
                onClick={handleToggleColorMode}
              >
                <IconButton>
                  {theme.palette.mode === "dark" ? (
                    <DarkModeOutlinedIcon />
                  ) : (
                    <LightModeOutlinedIcon />
                  )}
                </IconButton>
                <Typography
                  variant="h5"
                  style={{ color: "#ffffff", marginLeft: "10px" }}
                >
                  Theme
                </Typography>
              </Box>
            </Box>

            <Item
              title="Logout"
              // to="/"
              onClick={() => logout()}
              icon={<LogoutIcon />}
              selected={selected}
              setSelected={() => logout()}
            />
            
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
